import { Outlet } from "react-router-dom";

import SideNavBar from "@layout/dashboard/SideNavBar";
import { Guard } from "@auth/Guard";
import Header from "@layout/dashboard/Header";

const DashboardMainLayout = () => {
  var profile = Guard();
  const themeOption = {
    dark: {
      color: "#2D2D30",
      nav: "bg-dark text-white",
      inpuSearch: "bg-dark text-white",
      text: "text-white",
    },
    light: {
      color: "#F7F9FB",
      nav: "border bg-white text-dark",
      inpuSearch: "bg-white text-dark",
      text: "text-dark",
    },
  };
  const theme = themeOption[profile.mode];

  const outletContextValue = {
    profile,
    theme,
  };
  return (
    <div
      className="app-layout"
      style={{ background: theme.color }}
      id="app-layout"
    >

      <div className="pageWrap">
        <div className="page">
          <div className="aside">
            <div className="sidebar">
              <div className="sidebarBody">
                <SideNavBar profile={profile} theme={theme} />
              </div>
            </div>
          </div>
          <div className="mainWrap">
            <div className="mainSection">
              <div className="header">
                <div className="flex-container">
                  <Header profile={profile} theme={theme} />
                </div>
              </div>
              <div className="main">
                <div className="mainContent h-100">
                  <Outlet context={outletContextValue} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>





    // <div style={{ background: theme.color }} className="p-3 d-flex bg-white">

    // </div>
  );
};

export default DashboardMainLayout;
